import React from 'react'
import { Link } from 'react-router-dom'

const Subsribe = () => {
  return (
    <section className="subscribe-section-two">
  <div className="auto-container">
    <div className="content-box">
      <div className="sec-title text-center light">
        <span className="sub-title">Get The Latest Updates</span>
        <h2>Signup For Newsletter</h2>
        <div className="divider" />
      </div>
      <div className="newsletter-form-two">
        <form
          method="post"
          action="https://themecraze.net/html/volia/blog.html"
        >
          <div className="form-group">
            <input
              type="email"
              name="field-name"
              defaultValue=""
              placeholder="Signup For Newsletter"
              required=""
            />
            <button type="submit" className="theme-btn btn-style-two">
              <span className="btn-title">Subscribe</span>
            </button>
          </div>
        </form>
      </div>
      <div className="text">
        If You Want to Update For on Our Site a#<Link to="#">Subscribe</Link> Now.
      </div>
    </div>
  </div>
</section>


  )
}

export default Subsribe